export const floatValue = (value) => {
  return parseFloat(Math.round(value * 100) / 100);
};
